import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { Alert, Box, CircularProgress } from '@mui/material';
import { Order } from "@/api/SolarCloudApi";
import { useStripePaymentIntent } from "@/queries/payments/useStripePaymentIntent";
import StripePaymentRequestButton from "./StripePaymentRequestButton";
import { stripePromise } from "@/util/stripe";
import googlePayLogo from "@/res/logos/Google-Pay-Mark/google-pay-logo.png";

interface GooglePayPaymentFormProps {
  order: Order;
  onSuccess: (order: Order) => void;
  isSubmitting: boolean;
  setIsSubmitting?: (isSubmitting: boolean) => void;
  beforePayment?: () => Promise<boolean>;
}

export default function GooglePayPaymentForm({
  order,
  onSuccess,
  isSubmitting,
  setIsSubmitting,
  beforePayment,
}: GooglePayPaymentFormProps) {
  const { clientSecret, amount, error, loading } = useStripePaymentIntent(order.uuid!, "google_pay");

  if (error) {
    return <Alert severity="error">{error}</Alert>;
  }

  if (loading || !clientSecret) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Elements
      stripe={stripePromise}
      options={{
        clientSecret,
        appearance: { theme: 'stripe' },
      }}
    >
      <div className="space-y-4 py-4">
        <StripePaymentRequestButton
          type="google"
          label="SolarCloud Payment"
          amount={amount}
          onSuccess={() => onSuccess(order)}
          logo={googlePayLogo}
          clientSecret={clientSecret}
          orderUuid={order.uuid ?? ''}
          beforePayment={beforePayment}
        />
      </div>
    </Elements>
  );
}
